import domReady from '@wordpress/dom-ready';

domReady(() => {
  const btns = document.querySelectorAll(
    '.popup .btn, .home_banner .btn, .entry-content .btn, .wp-block-button .wp-element-button, .btn-secondary, .site-footer .btn-secondary'
  );

  if (btns) {
    btns.forEach((button) => {
      const parent = button.closest('.wp-block-button');

      button.innerHTML =
        '<span class="icon btn-icon icon-arrow-right-small"></span><span class="icon-label btn-label">' +
        button.innerHTML +
        '</span>';

      if (
        (parent && parent.classList.contains('is-style-secondary')) ||
        button.classList.contains('btn-secondary')
      ) {
        const icon = button.querySelector('.btn-icon');
        const text = button.querySelector('.btn-label');

        if (icon && text) {
          button.addEventListener('mouseenter', () => {
            const iconWidth = icon.offsetWidth;
            const textWidth = text.offsetWidth;

            icon.style.transform = `translateX(${textWidth}px)`;
            text.style.transform = `translateX(-${iconWidth}px)`;
          });

          button.addEventListener('mouseleave', () => {
            icon.style.transform = `translateX(0)`;
            text.style.transform = `translateX(0)`;
          });
        }
      }
    });
  }

  const btnSticky = document.querySelector('.sticky-button');
  if (btnSticky && window.innerWidth > 768) {
    const icon = btnSticky.querySelector('.sticky-button__icon');
    const text = btnSticky.querySelector('.sticky-button__title');

    if (icon && text) {
      btnSticky.addEventListener('mouseenter', () => {
        const iconWidth = icon.offsetWidth;
        const textWidth = text.offsetWidth;

        icon.style.transform = `translateX(-${textWidth}px)`;
        text.style.transform = `translateX(${iconWidth}px)`;
      });

      btnSticky.addEventListener('mouseleave', () => {
        icon.style.transform = `translateX(0)`;
        text.style.transform = `translateX(0)`;
      });
    }
  }

  const btnsDonation = document.querySelectorAll('.btn-donation');

  function updateActiveDonation() {
    btnsDonation.forEach((btn) => {
      const href = btn.getAttribute('href');
      if (href && window.location.href.includes(href)) {
        btn.classList.add('btn-donation-active');
      } else {
        btn.classList.remove('btn-donation-active');
      }
    });
  }

  updateActiveDonation();

  btnsDonation.forEach((btn) => {
    btn.addEventListener('click', () => {
      setTimeout(updateActiveDonation, 100);
    });
  });

  const copyShareButtons = document.querySelectorAll('[data-share-copy]');

  function copyText(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value);
    }

    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);

    return Promise.resolve();
  }

  copyShareButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const shareLinks = button.closest('.share-links');
      const shareUrl =
        (shareLinks && shareLinks.getAttribute('data-share-url')) ||
        window.location.href;
      const shareTitle =
        (shareLinks && shareLinks.getAttribute('data-share-title')) ||
        document.title;

      if (navigator.share) {
        navigator.share({ title: shareTitle, url: shareUrl }).catch(() => {
          copyText(shareUrl);
        });
        return;
      }

      copyText(shareUrl);
    });
  });
});
